import { ZAttributeValue, zAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";
import { apiObjUrl } from "./apiUrl";
import { restWithObjectVersion } from "./restWithObjectVersion";

export const loadRefDict = async (
  refId: ZUid,
  options: {
    translate?: boolean;
  } = {},
): Promise<ZAttributeValue[]> => {
  const resp = await restWithObjectVersion.get(
    apiObjUrl(`/attributes/${refId}`),
    { translate: options.translate },
  );
  return zAttribute.parse(resp.data).values || [];
};
